let selectedEnv = 'development';
const env = require(`./${selectedEnv}`)
export const ENVIRONMENTS = env[selectedEnv.toUpperCase()]